import { SetStateAction } from 'react'
import {
  CargoItemInterface,
  Location,
  SlotItemInterface,
  TransportItemInterface,
} from '../../../types/interfaces'
import classes from './GMapForRoute.module.sass'
import { useGMapForRoute } from './hooks/useGMapForRoute'

type Props = {
  data: SlotItemInterface | TransportItemInterface | CargoItemInterface
  intercity: boolean
  addresses?: boolean
  setData?: React.Dispatch<
    SetStateAction<SlotItemInterface | CargoItemInterface | SlotItemInterface>
  >
}

export const GMapForRoute = ({ data, intercity, addresses, setData }: Props) => {
  useGMapForRoute(data, intercity, addresses, setData)

  return <div id="map" className={classes.Map} />
}
